import controller from './fast-import-block.controller';
import template from './fast-import-block.html';

import './fast-import-block.scss';

export default {
	template,
	controller,
};
